import { Injectable } from '@angular/core';
import { StorageService } from '../service/storage/storage.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../spartacus/features/asm/asm-constant';

@Injectable({
  providedIn: 'root',
})
export class AsmCheckerService {
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  constructor(private storageService: StorageService) {
    this.isAsmEnabled();
  }

  isAsmEnabled() {
    return this.asmEnabled === 'true';
  }
}
